// TODO(HABITS-328): Remove this hook after V2 1:1s GA rollout
import { useCurrentCompany } from './use-current-company';
import { useCurrentUser } from './use-current-user';
import { useSpoofing } from './use-spoofing';

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * TEMPORARY: Hook to check if the current user can access V2 1:1 features.
 *
 * V2 access is granted to:
 * - Bonusly company users (is_bonusly_company)
 * - Local development environments (for testing)
 * - Superadmins spoofing with permissions ON (for migration testing - HABITS-348)
 *
 * This hook centralizes the V2 access pattern and should be used
 * consistently across all V2 1:1 feature checks.
 *
 * @see HABITS-328 - Remove after V2 GA rollout to all companies
 */
export const useCanAccessV2 = (): boolean => {
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const { isSpoofing } = useSpoofing();

	// V2 access for Bonusly company or local development
	if (company?.is_bonusly_company) return true;
	if (isDevelopment) return true;

	// Superadmin spoofing with permissions ON → V2 for migration testing (HABITS-348)
	if (isSpoofing && user?.show_superadmin_feature) return true;

	return false;
};
